import styled from "styled-components";
import { colorToken } from "components/utils/constants";
import breakpoint from "components/utils/responsive";
import { Link } from 'react-router-dom';
export const ReturnTheme = (theme) => {
    const objThemes = {
        theme1: {
            background: colorToken.black,
            linkColor: colorToken.white,
            linkColorHover: colorToken.color2,
        },
        theme2: {
            background: colorToken.color1,
            linkColor: colorToken.color2,
            linkColorHover: colorToken.color3,
        },
        theme3: {
            background: colorToken.color2,
            linkColor: colorToken.white,
            linkColorHover: colorToken.color1,
        },
    };

    return objThemes[theme] || objThemes.theme1;
};

export const LogoVw = () => (
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 518.66 248.68">
  <path d="M83.04,53.58C37.04,53.58,0,90.62,0,136.62s37.04,83.04,83.04,83.04,83.04-37.04,83.04-83.04-37.04-83.04-83.04-83.04M83.04,61.05c8.64,0,16.94,1.49,24.58,4.32l-23.59,53.15c-.33.67-.5,1-1,1s-.66-.5-1-1l-23.59-53.15c7.64-2.82,15.94-4.32,24.58-4.32M46.84,70.69l27.57,61.29c.33,1,1.16,1.33,1.99,1.33h13.29c1,0,1.66-.17,2.16-1.33l27.57-61.29c10.96,6.15,20.26,14.95,27.07,25.41l-38.53,77.06c-.17.5-.5,1-1,1s-.66-.5-1-1l-14.45-32.89c-.5-1.16-1.16-1.33-2.16-1.33h-13.29c-1,0-1.66.17-2.16,1.33l-13.95,32.89c-.17.5-.5,1-1,1s-.66-.5-1-1L19.76,96.1c6.81-10.46,15.94-19.27,27.07-25.41M83.04,212.03c-41.36,0-75.24-34.05-75.24-75.4,0-9.3,1.66-18.1,4.82-26.41l44.01,88.52c.5,1.16,1.33,2.16,2.66,2.16s2.16-1,2.66-2.16l20.26-45.34c.16-.5.5-1,1-1s.66.5,1,1l20.26,45.34c.5,1.16,1.33,2.16,2.66,2.16s2.16-1,2.66-2.16l44.01-88.52c3.16,8.3,4.82,17.11,4.82,26.41-.33,41.36-34.21,75.4-75.57,75.4" fill="#1f2a4b"/>
  <line x1="262.42" y1="103.94" x2="262.42" y2="176.92" fill="none" stroke="#1f2a4c" stroke-miterlimit="10" stroke-width="3.26"/>
  <polygon points="440.03 27.47 436.74 17.13 445.13 10.78 445.13 10.34 434.63 10.34 431.34 0 430.97 0 427.76 10.34 417.26 10.34 417.26 10.78 425.58 17.13 422.36 27.47 422.96 27.47 431.16 21.34 439.43 27.47 440.03 27.47" fill="#f2cc32"/>
  <polygon points="400.01 38.42 396.72 28.08 405.11 21.73 405.11 21.29 394.62 21.29 391.32 10.95 390.96 10.95 387.74 21.29 377.24 21.29 377.24 21.73 385.56 28.08 382.34 38.42 382.94 38.42 391.14 32.29 399.41 38.42 400.01 38.42" fill="#f2cc32"/>
  <polygon points="462.47 38.42 465.76 28.08 457.36 21.73 457.36 21.29 467.86 21.29 471.15 10.95 471.52 10.95 474.74 21.29 485.24 21.29 485.24 21.73 476.92 28.08 480.14 38.42 479.54 38.42 471.34 32.29 463.07 38.42 462.47 38.42" fill="#f2cc32"/>
  <polygon points="366.6 62.92 363.31 52.59 371.7 46.23 371.7 45.79 361.2 45.79 357.91 35.45 357.54 35.45 354.33 45.79 343.83 45.79 343.83 46.24 352.14 52.59 348.93 62.92 349.53 62.92 357.72 56.79 365.99 62.92 366.6 62.92" fill="#f2cc32"/>
  <polygon points="513.46 62.92 510.17 52.59 518.56 46.23 518.56 45.79 508.07 45.79 504.77 35.45 504.41 35.45 501.19 45.79 490.69 45.79 490.69 46.24 499.01 52.59 495.79 62.92 496.39 62.92 504.59 56.79 512.86 62.92 513.46 62.92" fill="#f2cc32"/>
  <path d="M431.24,233.58c-11-9.84-21.75-14.18-30.73-17.81-10.38-4.19-17.88-7.23-23.96-17.33-4.09-6.78-6.24-14.75-6.24-23.05v-59.67c0-8.22-1.8-16.12-5.36-23.49-.55-1.14-1.15-2.26-1.78-3.36,12.62-4.46,21.52-11.94,29.67-18.79,11.39-9.57,20.39-17.13,38.41-17.13s27.4,7.9,37.38,16.27l1.01.85c8.15,6.84,17.05,14.33,29.67,18.79-4.62,8.07-7.12,17.29-7.12,26.85v59.67c0,8.29-2.16,16.26-6.24,23.06-5.79,9.63-12.36,12.64-23.46,17.13l-.52.21c-8.98,3.63-19.72,7.98-30.71,17.8" fill="#4c65aa"/>
  <path d="M475.72,107.49v58.34h-.52l-11.68-11.72c-1.64-1.64-3.86-2.56-6.18-2.56h-11.18v11.2c0,2.31.92,4.53,2.55,6.16l11.72,11.71v.52h-58.33v-.52l11.72-11.71c1.63-1.64,2.55-3.86,2.55-6.16v-11.19h-11.24c-2.32,0-4.54.92-6.17,2.56l-11.68,11.72h-.52v-58.35h.52l11.68,11.72c1.64,1.64,3.86,2.56,6.17,2.56h11.24v-11.19c0-2.31-.92-4.53-2.55-6.16l-11.72-11.71v-.52h58.33v.52l-11.72,11.71c-1.63,1.64-2.55,3.86-2.55,6.16v11.2h11.18c2.32,0,4.54-.92,6.18-2.56l11.68-11.72h.52Z" fill="#fff"/>
  <path d="M408.61,138.05c0,.92.06,1.68.18,2.27.12.59.35,1.06.68,1.4.33.34.78.57,1.35.71.57.13,1.31.2,2.21.2h2.68c.44,0,.95,0,1.54-.02.58-.01,1.28-.03,2.1-.05l-.92,5.04c-.7.02-1.29.04-1.77.05-.48.01-.91.02-1.29.02h-2.74c-1.86,0-3.44-.16-4.73-.49-1.29-.33-2.34-.86-3.15-1.61-.81-.75-1.4-1.74-1.77-2.96-.37-1.23-.55-2.75-.55-4.58v-2.73c0-1.74.18-3.23.55-4.45.37-1.23.96-2.22,1.78-2.98.82-.76,1.87-1.31,3.15-1.66,1.28-.35,2.84-.52,4.68-.52h2.77c.46,0,1,0,1.61.02.61.01,1.34.03,2.18.05l-.92,5.04c-.98-.04-1.81-.06-2.49-.06h-2.76c-.9,0-1.64.07-2.21.2-.58.13-1.03.37-1.35.71-.33.34-.55.8-.66,1.4-.11.59-.17,1.35-.17,2.27v2.76Z" fill="#2d3369"/>
  <path d="M427.88,143.11h4.69c.94,0,1.61-.15,2-.45.39-.3.58-.86.58-1.67v-.4c0-.86-.2-1.44-.6-1.73-.4-.3-1.09-.45-2.07-.45h-4.6v4.7ZM434.54,132.03c0-.65-.16-1.12-.49-1.4-.33-.28-.89-.41-1.69-.41h-4.48v4.02h4.38c.84,0,1.43-.15,1.77-.44.34-.3.51-.78.51-1.46v-.31ZM422.39,125.73h11.17c2.33,0,4.03.46,5.08,1.37,1.05.91,1.58,2.27,1.58,4.07v.4c0,2.13-.85,3.6-2.55,4.42,1.02.39,1.81.99,2.37,1.8.55.81.83,1.87.83,3.18v.55c0,2.15-.64,3.7-1.94,4.65-1.29.95-3.23,1.43-5.81,1.43h-10.74v-21.87Z" fill="#2d3369"/>
  <polygon points="460.04 125.73 459.15 130.52 449.3 130.52 449.3 134.76 458.63 134.76 457.77 139.4 449.3 139.4 449.3 147.6 443.52 147.6 443.52 125.73 460.04 125.73" fill="#2d3369"/>
  <rect x="373.01" y="121.77" width="13.76" height="14.89" fill="#5b9f50"/>
  <rect x="475.72" y="136.66" width="13.76" height="14.89" fill="#5b9f50"/>
  <path d="M489.47,175.38c0,7.8-2.02,15.29-5.86,21.65-5.61,9.33-12.39,12.06-22.65,16.22-4.48,1.81-9.51,3.85-14.83,6.69v-38.8h-14.89v48.84c-10.72-9.05-21.2-13.29-29.7-16.73-10.27-4.15-17.05-6.89-22.67-16.22-3.83-6.36-5.86-13.85-5.86-21.65v-23.82h13.76v-14.89h-13.76v-20.95c0-8.84-2.07-17.57-5.99-25.41,11.55-4.7,20.02-11.81,27.57-18.15,7.48-6.28,13.62-11.41,21.76-14.2v34.24h14.89v-36.53h0c17.02,0,25.26,6.92,36.65,16.49,7.55,6.34,16.02,13.46,27.57,18.15-3.93,7.84-5.99,16.57-5.99,25.41v6.06h-13.76v14.89h13.76v38.71ZM502.77,121.77h-10.59v-6.06c0-9.56,2.51-18.78,7.12-26.85-12.61-4.46-21.51-11.94-29.65-18.78-11.39-9.57-20.39-17.13-38.4-17.13h0v-10.59c-5.58,0-10.48.65-14.89,1.76v10.98c-9.11,2.9-15.76,8.47-23.5,14.98-8.14,6.83-17.05,14.32-29.66,18.78,4.62,8.08,7.12,17.29,7.12,26.85v20.95h-10.58v14.89h10.58v23.82c0,8.29,2.16,16.26,6.24,23.05,6.09,10.11,13.58,13.14,23.96,17.33,8.99,3.64,19.74,7.98,30.74,17.82v15.11s0,0,0,0c5.01-5.81,10-10.01,14.89-13.28v-12.39c5.64-3.12,11-5.3,15.84-7.26,10.38-4.19,17.89-7.22,23.96-17.33,4.09-6.79,6.24-14.76,6.24-23.05v-38.71h10.59v-14.89Z" fill="#f2cc32"/>
  <path d="M446.13,57.94c-4.26-1.46-9.05-2.29-14.89-2.29h0v36.53h14.89v-34.24Z" fill="#5b9f50"/>
  <path d="M416.35,219.93c4.79,2.55,9.81,5.76,14.89,10.05v-48.85h-14.89v38.8Z" fill="#5b9f50"/>
  <path d="M431.24,52.95c18.01,0,27.01,7.56,38.4,17.13,8.14,6.83,17.04,14.32,29.65,18.78-4.61,8.07-7.12,17.29-7.12,26.85v6.06h10.59v-6.06c0-13.54,6.2-25.63,15.9-33.61-20.61-1.51-31.85-11.44-43.24-21-11.4-9.56-22.95-18.74-44.18-18.74h0v10.59h0Z" fill="#2d3369"/>
  <path d="M370.3,115.71c0-9.56-2.49-18.78-7.12-26.85,12.61-4.46,21.52-11.94,29.66-18.78,7.74-6.51,14.39-12.07,23.5-14.98v-10.98c-29.18,7.33-36.74,35.37-72.53,37.98,4.86,3.99,8.82,9.01,11.59,14.72,2.76,5.71,4.31,12.12,4.31,18.89v20.95h10.58v-20.95Z" fill="#2d3369"/>
  <path d="M400.5,215.75c-10.38-4.19-17.88-7.22-23.96-17.33-4.08-6.79-6.24-14.76-6.24-23.05v-23.82h-10.58v23.82c0,10.02,2.58,19.92,7.76,28.51,15.56,25.87,39.32,16.5,63.74,44.76v-15.1c-10.99-9.83-21.73-14.16-30.71-17.8" fill="#2d3369"/>
  <path d="M492.18,175.38c0,8.29-2.15,16.26-6.24,23.05-6.08,10.11-13.58,13.14-23.96,17.33-4.85,1.97-10.22,4.14-15.87,7.28v12.39c7.03-4.7,13.88-7.43,20.34-10.04,10.94-4.43,20.78-8.55,28.57-21.49,5.16-8.59,7.76-18.49,7.76-28.51v-38.72h-10.59v38.72Z" fill="#2d3369"/>
</svg>
);

export const StyleHeader = styled.header`
    position: fixed;
    padding: 16px;
    width: 100%;
    top: 0;
    z-index: 100;
    transition: all 0.2s;
    background-color: ${colorToken.white};

    svg {
        height: 45px;
    }

    > div {
        max-width: 960px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        > div {
            display: flex;
            align-items: center;
            &:last-of-type {
                justify-content: flex-end;
            }
            &:first-of-type {
                
            }
        }
    }

    &.is-sticky {
    }

    @media ${breakpoint.lg} {
     svg {
        height: 63px;
    }
        > div {
        > div {
            &:last-of-type {

            }
            &:first-of-type {
                flex-grow: 1;
                flex-basis: 0;
            }
        }
    }
    }
`;

export const StyleVolksHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 0 20px;
    padding: 12px 0;
    svg {
        width: 39px;
    }
    @media ${breakpoint.lg} {
        padding: 12px 0;
    }
`
export const StyleLineLeft = styled.div`
    height: 2px;
    border-radius: 0 1px 1px 0;
    background-color: ${colorToken.white};
    flex-grow: 1;
    box-shadow: 1px 0 rgba(0,71,118, 0.4);
`
export const StyleLineRight = styled.div`
    height: 2px;
    border-radius: 1px 0 0 1px;
    background-color: ${colorToken.white};
    flex-basis: 16%;
`
export const StyleLogo = styled.div`
    flex-basis: 42px;
    @media ${breakpoint.lg} {
        flex-basis: 42px;
    }
`

export const StyleMenu = styled.nav`
    margin: 0 auto;
    position: fixed;
    background-color: rgba(255, 255, 255, 0.95);
    top: 65px;
    display: flex;
    left: 0;
    right: 0;
    bottom: 0;
    height: ${({ showMenu }) => (showMenu ? "calc(100vh - 55px)" : "0vh")};
    padding-top: ${({ showMenu }) => (showMenu ? "16px" : "0")};
    transition: all linear 0.4s;
    flex-direction: column;
    overflow: hidden;
    @media ${breakpoint.lg} {
        position: unset;
        height: unset;
        display: flex;
        flex-direction: row;
        padding: 0;
        gap: 0 24px;
    }
`

export const StyleMenuItem = styled(Link)`
    color: ${colorToken.color2};
    text-decoration: none;
    font-weight: 600;
    font-size: 16px;
    padding: 16px 24px;
    @media ${breakpoint.lg} {
        /* display: flex;
        gap: 0 24px; */
        padding: 0;
    }
    `

export const StyleButtonGroup = styled.div`
    flex-grow: 1;
    flex-basis: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 6px;

    @media ${breakpoint.lg} {
        flex-direction: row;
        align-items: center;
        gap: 0 8px;
    }
`;

export const StyleButtonHamburger = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    padding: 0;
    width: 32px;
    margin-left: 8px;
    .line {
        fill: none;
        stroke: ${colorToken.color2};
        stroke-width: 6;
        transition: stroke-dasharray 600ms cubic-bezier(0.4, 0, 0.2, 1),
            stroke-dashoffset 600ms cubic-bezier(0.4, 0, 0.2, 1);
    }
    .line1 {
        stroke-dasharray: 60 207;
        stroke-width: 6;
    }
    .line2 {
        stroke-dasharray: 60 60;
        stroke-width: 6;
    }
    .line3 {
        stroke-dasharray: 60 207;
        stroke-width: 6;
    }
    &.opened .line1 {
        stroke-dasharray: 90 207;
        stroke-dashoffset: -134;
        stroke-width: 6;
    }
    &.opened .line2 {
        stroke-dasharray: 1 60;
        stroke-dashoffset: -30;
        stroke-width: 6;
    }
    &.opened .line3 {
        stroke-dasharray: 90 207;
        stroke-dashoffset: -134;
        stroke-width: 6;
    }
    @media ${breakpoint.lg} {
        display: none;
    }
`;